import { useEffect } from 'react';

// Creates ripple effect on button/link clicks
const MicroFeedback = () => {
  useEffect(() => {
    const createRipple = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const isInteractive = target.tagName === 'BUTTON' || 
                           target.tagName === 'A' ||
                           target.closest('button') ||
                           target.closest('a');
      
      if (!isInteractive) return;
      
      const element = (target.tagName === 'BUTTON' || target.tagName === 'A') 
        ? target 
        : (target.closest('button') || target.closest('a'));
      
      if (!element) return;

      const rect = element.getBoundingClientRect();
      const ripple = document.createElement('span');
      
      const size = Math.max(rect.width, rect.height);
      const x = e.clientX - rect.left - size / 2;
      const y = e.clientY - rect.top - size / 2;
      
      ripple.style.cssText = `
        position: absolute;
        width: ${size}px;
        height: ${size}px;
        left: ${x}px;
        top: ${y}px;
        background: currentColor;
        opacity: 0.1;
        border-radius: 50%;
        transform: scale(0);
        animation: ripple-effect 0.6s ease-out forwards;
        pointer-events: none;
      `;
      
      // Ensure element has relative positioning for ripple
      const computedStyle = window.getComputedStyle(element);
      if (computedStyle.position === 'static') {
        (element as HTMLElement).style.position = 'relative';
      }
      (element as HTMLElement).style.overflow = 'hidden';
      
      element.appendChild(ripple);
      
      setTimeout(() => ripple.remove(), 600);
    };

    document.addEventListener('click', createRipple);
    return () => document.removeEventListener('click', createRipple);
  }, []);

  return null;
};

export default MicroFeedback;
